<script setup>
import CLink from "@/Components/CLink.vue"
import {computed} from "vue"
import {useDisplay} from "vuetify"

const display = useDisplay()
const props = defineProps({
    items: Array
})

const breadCrumbItems = computed(() => {
    // simplifica o breadcrumb quando mobile
    if (props.items.length > 3 && display.name.value === 'xs') {
        return props.items.slice(0, 1)
            .concat({url: '', disabled: true, title: '...'})
            .concat(props.items.slice(-2))
    }

    return props.items
})
</script>
<template>
    <v-breadcrumbs :items="breadCrumbItems" divider="/">
        <template v-slot:item="{ item, index }">
            <span v-if="item.disabled || !item.url || index === breadCrumbItems.length - 1">{{ item.title }}</span>
            <c-link v-else :href="item.url || ''" :class="{ 'text-gray-400' : item.disabled}">
                {{ item.title }}
            </c-link>
        </template>
    </v-breadcrumbs>
</template>
